import React from 'react'
import { useTranslation } from 'react-i18next'

const CarouselReadonly = (props) => {
  const {
    images,
    selectedImageId,
  } = props
  const { t } = useTranslation()

  const image = images.find((image) => image.id === selectedImageId)
  if (!image) return null

  // return
  return (
    <div className="info-card-readonly">
      {image.headline ? (
        <div className="section">
          <p className="section-title">
            {t('Recommendations.campaign.published.headline')}
          </p>
                
          <p className="section-body">{image.headline}</p>
        </div>
      ) : null}

      {image.description ? (
        <div className="section">
          <p className="section-title">
            {t('Recommendations.campaign.published.description')}
          </p>
                
          <p className="section-body">{image.description}</p>
        </div>
      ) : null}

      {image.url ? (
        <div className="section mb-0">
          <p className="section-title">
            {t('Recommendations.campaign.published.destinationUrl')}
          </p>
                
          <p className="section-body">{image.url}</p>
        </div>
      ) : null}
    </div>
  )
}

export default CarouselReadonly